import * as LabelPrimitive from '@radix-ui/react-label'
import { cva, type VariantProps } from 'class-variance-authority'
import { type ComponentProps } from 'react'

import { cn } from '#app/utils/misc'

const labelVariants = cva(
	'block text-sm leading-5 font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
	{
		variants: {
			size: {
				default: '',
				lg: 'text-lg font-semibold',
			},
		},
		defaultVariants: {
			size: 'default',
		},
	},
)

type LabelProps = ComponentProps<typeof LabelPrimitive.Root> &
	VariantProps<typeof labelVariants>

const Label = ({ className, size, ...props }: LabelProps) => (
	<LabelPrimitive.Root
		data-slot="label"
		className={cn(labelVariants({ size }), className)}
		{...props}
	/>
)

export { Label }
